import type { I18n } from "i18n-js";

/**
 * "12,500 places" — how a city's venue count reads wherever it is shown.
 *
 * Shared because the browse card and the search row both say it and they must
 * not drift apart. Takes the `i18n` instance rather than calling `useI18N`
 * itself so it stays usable from callbacks and `useMemo` bodies.
 *
 * Its own keys rather than the existing `place` / `places`: `places` is
 * declared twice in `localizations.js` and the later definition ("Places", a
 * section heading) is the one that wins.
 */
export const formatPlaces = (i18n: I18n, count: number) =>
  i18n
    .get(count === 1 ? "onboardingPlaceCount" : "onboardingPlacesCount")
    .replace("{count}", count.toLocaleString());
